import React from "react";
import styles from "./styles.module.scss";

const ProductSkeleton: React.FC = () => {
    return (
        <section className={`${styles.skeleton_product}`}>
            <div className={`${styles.skeleton_product_left}`}>
                <div className={`${styles.skeleton_images}`}>
                    <div className={`${styles.skeleton_thumbs}`}>
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className={`${styles.skeleton_thumb}`}></div>
                        ))}
                    </div>
                    <div className={`${styles.skeleton_main_image}`}></div>
                </div>
            </div>

            <div className={`${styles.skeleton_product_right}`}>
                <div className={`${styles.skeleton_title}`}></div>
                <div className={`${styles.skeleton_review}`}>
                    <div className={`${styles.skeleton_stars}`}>
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className={`${styles.skeleton_star}`}></div>
                        ))}
                    </div>
                    <div className={`${styles.skeleton_review_text}`}></div>
                </div>

                <div className={`${styles.skeleton_step_nav}`}>
                    {[...Array(3)].map((_, i) => (
                        <div key={i} className={`${styles.skeleton_step_indicator}`}>
                            <div className={`${styles.skeleton_step_number}`}></div>
                            <div className={`${styles.skeleton_step_text}`}></div>
                        </div>
                    ))}
                </div>

                <div className={`${styles.skeleton_step_content}`}>
                    <div className={`${styles.skeleton_step_title}`}></div>
                    <div className={`${styles.skeleton_dropdowns}`}>
                        {[...Array(3)].map((_, i) => (
                            <div key={i} className={`${styles.skeleton_dropdown}`}></div>
                        ))}
                    </div>
                    <div className={`${styles.skeleton_features}`}>
                        {[...Array(3)].map((_, i) => (
                            <div key={i} className={`${styles.skeleton_feature}`}></div>
                        ))}
                    </div>
                    
                </div>

                <div className={`${styles.skeleton_button}`}></div>
            </div>
        </section>
    );
};

export default ProductSkeleton;